<template>
  <v-app>
    <!--<core-filter />-->
    <div v-if="loggedIn">
      <core-toolbar />
      <core-drawer />
    </div>

    <core-view />
  </v-app>
</template>

<script>
  export default {
    computed: {
      loggedIn() {
        return this.$store.getters.loggedIn
      }
    }
  }
</script>

<style lang="scss">
@import '@/styles/index.scss';

/* Remove in 1.2 */
.v-datatable thead th.column.sortable i {
  vertical-align: unset;
}
</style>
